import { render, staticRenderFns } from "./AskingForSamples.vue?vue&type=template&id=211d4916&scoped=true&"
import script from "./AskingForSamples.vue?vue&type=script&lang=js&"
export * from "./AskingForSamples.vue?vue&type=script&lang=js&"
import style0 from "./AskingForSamples.vue?vue&type=style&index=0&id=211d4916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211d4916",
  null
  
)

export default component.exports